import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from "@angular/core";
import { StatusCodes } from "@obg/ngx.global";

@Component({
	templateUrl: "./not-found.container.html",
	styleUrls: ["./not-found.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class NotFoundContainer {
	@HostBinding("class.obg-not-found") hostCssClass = true;

	statusCode = StatusCodes.NotFound;
}
